export default "__VITE_ASSET__Bpgxw8bK__"